import ContentPane from './components/ContentPane.vue'
import Workspace from './Workspace.vue'
import AppForm from './editor/app/AppForm.vue'
import TableForm from './editor/app/TableForm.vue'
import TableDetails from './editor/app/TableDetails.vue'
import ShowView from "./views/ShowView.vue"
import AppEditor from "./editor/app/AppEditor.vue";
import ViewManager from "./views/ViewManager.vue";
import OpenApp from "./editor/app/OpenApp.vue";
import AppContainer from "./AppContainer.vue";
import Collaborators from "./editor/app/Collaborators.vue";
import ViewEditor from "./editor/view/ViewEditor.vue";
import PageEditor from "./editor/page/PageEditor.vue";
import OpenSite from "./views/OpenSite.vue";
import Integrations from "./Integrations.vue";
import Notifications from "./notifications/NotificationsContainer.vue";
import LinkedObjectForm from "./views/form/LinkedObjectForm.vue";
import Marketplace from "./marketplace/Marketplace.vue";
import SignIn from "./SignIn.vue";
import SignUp from "./SignUp.vue";
import LayoutEditor from "./editor/experimental/LayoutEditor.vue";
import DetailsContainer from "./views/DetailsContainer.vue";
import FormContainer from "./views/form/FormContainer.vue";
// import Web3App from "./web3/Web3App";

import {createRouter, createWebHistory} from 'vue-router'

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        {
            path: '/workspace',
            component: ContentPane,
            redirect: '/workspace/apps',
            children: [
                {
                    path: 'apps',
                    name: 'apps',
                    component: Workspace
                },
                {
                    path: 'sign-in',
                    name: 'sign-in',
                    component: SignIn
                },
                {
                    path: 'sign-up',
                    name: 'sign-up',
                    component: SignUp
                },
                {
                    path: 'new-app',
                    name: 'new-app',
                    component: AppForm
                },
            ]
        },
        {
            path: '/workspace/app',
            component: AppContainer,
            children: [
                {
                    path: 'edit-app/:id',
                    name: 'edit-app',
                    component: AppForm
                },
                {
                    path: 'collaborators/:id',
                    name: 'collaborators',
                    component: Collaborators
                },
                {
                    path: 'open-app/:id',
                    name: 'open-app',
                    component: OpenApp
                },
                {
                    path: 'marketplace/:id',
                    name: 'marketplace',
                    component: Marketplace
                },
                {
                    path: ':appId/site/:id',
                    name: 'open-site',
                    component: OpenSite
                },
                {
                    path: 'view/:id',
                    name: 'view-renderer',
                    component: ViewManager
                },
                {
                    path: 'app-editor/:id',
                    name: 'app-editor',
                    component: AppEditor
                },
                // {
                //     path: 'web3-app/:id',
                //     name: 'web3-app',
                //     component: Web3App
                // },
                {
                    path: 'view-editor/:id',
                    name: 'view-editor',
                    component: ViewEditor
                },
                {
                    path: 'exp-layout-editor/:id',
                    name: 'exp-layout-editor',
                    component: LayoutEditor
                },
                {
                    path: 'integrations/:id',
                    name: 'integrations',
                    component: Integrations
                },
                {
                    path: 'notifications/:id',
                    name: 'notifications',
                    component: Notifications
                },
                {
                    path: ':appId/layout-editor/:siteId/:layoutType',
                    name: 'layout-editor',
                    component: PageEditor,
                    props: true
                },
                {
                    path: ':appId/page-editor/:pageId',
                    name: 'page-editor',
                    component: PageEditor,
                    props: true
                },
                {
                    path: 'app/:app_id/new-table',
                    name: 'new-table',
                    component: TableForm
                },
                {
                    path: 'edit-table/:id',
                    name: 'edit-table',
                    component: TableForm
                },
                {
                    path: 'table/:id',
                    name: 'table-details',
                    component: TableDetails
                },
                {
                    path: 'details/:table_id/:record_id',
                    name: 'static-details',
                    component: ShowView,
                    props: true
                },
                {
                    path: 'details-view/:view_id/:record_id',
                    name: 'details-view',
                    component: DetailsContainer
                },
                {
                    path: 'new/:table_id',
                    name: 'new-object',
                    // component: StaticFormView,
                    component: FormContainer,
                    props: true
                },
                {
                    path: 'edit/:table_id/:document_id',
                    name: 'edit-object',
                    // component: StaticFormView,
                    component: FormContainer,
                    props: true
                },
                {
                    path: 'new-child-object/:parent_table_id/:parent_document_id/:table_id',
                    name: 'new-child-object',
                    component: LinkedObjectForm,
                    props: true
                }
            ]
        }
    ]
})

export default router